(() => {
  const key='antigranizo-delivery-v1';
  const read=()=>{try{return localStorage.getItem(key)==='pickup'?'pickup':'shipping';}catch{return 'shipping';}};
  let current=read();
  window.agDelivery=()=>current;
  const render=()=>document.querySelectorAll('[data-delivery]').forEach(block=>{
    block.querySelectorAll('input[name="delivery"]').forEach(input=>input.checked=input.value===current);
    block.querySelector('[data-pickup-address]').hidden=current!=='pickup';
  });
  document.querySelectorAll('[data-delivery]').forEach(block=>block.addEventListener('change',event=>{
    if(event.target.name!=='delivery')return;
    current=event.target.value==='pickup'?'pickup':'shipping';
    try{localStorage.setItem(key,current);}catch{}
    render();document.dispatchEvent(new Event('ag:delivery'));
  }));
  window.addEventListener('storage',event=>{if(event.key===key){current=read();render();document.dispatchEvent(new Event('ag:delivery'));}});
  render();
})();
